import { BACKEND_URL } from '../config/api';

/**
 * Resolve an image URL — handles both legacy MongoDB paths (/api/images/xxx)
 * and new R2 direct URLs (https://pub-xxx.r2.dev/...).
 */
export function resolveImageUrl(url) {
  if (!url) return null;
  if (url.startsWith('http://') || url.startsWith('https://')) return url;
  return `${BACKEND_URL}${url}`;
}
